import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ActivatedRoute, Router} from "@angular/router";
import {EVENT_CALENDAR_ROUTE} from "src/app/app-routing.module";
import {TranslocoService} from "@ngneat/transloco";
import {passwordStrengthValidator, required} from "@utility";
import {AuthenticationService, TOAST_STATE, ToastService} from "@services";
import {AccountRecoveryUser, Message} from "@model";

@Component({
  selector: 'app-change-password-on-recovery',
  templateUrl: './change-password-on-recovery.component.html',
  styleUrls: ['./change-password-on-recovery.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class ChangePasswordOnRecoveryComponent implements OnInit {
  @Input() unreadMessages: Message[] | undefined;
  changePasswordOnRecoveryComponentState: ChangePasswordOnRecoveryComponentState = ChangePasswordOnRecoveryComponentState.INITIAL;
  changePasswordOnRecoveryComponentStateType = ChangePasswordOnRecoveryComponentState;

  userid?: number;
  token?: string;

  inputForm = new FormGroup(
    {
      password: new FormControl('', [required, passwordStrengthValidator()]),
      confirmPassword: new FormControl('', [required, passwordStrengthValidator()]),

    }
  );
  constructor(private authService: AuthenticationService, private route: ActivatedRoute, private router: Router, private toastService: ToastService,
              private translocoService: TranslocoService) {
  }

  ngOnInit(): void {
    this.userid = +this.route.snapshot.queryParams['userid'];
    this.token = this.route.snapshot.queryParams['token'];
  }

  /// example of a verification link
  // http://localhost:4200/changePasswordOnRecovery?userid=429&token=f609e7af-a6d3-491a-aff3-c506ff2d2cbe
  onSubmit(): void {
    if (!this.inputForm.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
    if (this.inputForm.value.password !== this.inputForm.value.confirmPassword) {
      this.changePasswordOnRecoveryComponentState = ChangePasswordOnRecoveryComponentState.PASSWORDS_DO_NOT_MATCH
      return;
    }
    this.authService.accountRecovery(new AccountRecoveryUser(this.userid!, this.token!, <string>this.inputForm.value.password, <string>this.inputForm.value.confirmPassword), () => {
      this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate('change.password.on.recovery.success'));
      this.router.navigate([EVENT_CALENDAR_ROUTE]);
    }, (value: number) => {
      if (value === AuthenticationService.TOKEN_NOT_VALID) {
        this.changePasswordOnRecoveryComponentState = ChangePasswordOnRecoveryComponentState.VERIFICATION_LINK_EXPIRED;
      }
      if (value === AuthenticationService.PASSWORDS_DO_NOT_MATCH) {
        this.changePasswordOnRecoveryComponentState = ChangePasswordOnRecoveryComponentState.PASSWORDS_DO_NOT_MATCH;
      }
    });
  }
}

enum ChangePasswordOnRecoveryComponentState {
  INITIAL,
  VERIFICATION_LINK_EXPIRED,
  PASSWORDS_DO_NOT_MATCH,
}

